// Archivo para el botón de creación

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Icon from '@mui/icons-material/Add';

const CreateButton = ({ entityType, onClick, loading, disabled }) => {
    const { t } = useTranslation();

    const buttonText = loading
        ? t('buttons.creating')
        : t(`buttons.create${entityType.charAt(0).toUpperCase() + entityType.slice(1)}`);

    return (
        <button
            className={`button create-button ${entityType}-create-button`}
            onClick={onClick}
            disabled={disabled || loading}
            aria-label={buttonText}
        >
            <Icon fontSize="small" />
            {!loading && <span>{buttonText}</span>}
            {loading && <span className="button-spinner" />}
        </button>
    );
};

CreateButton.propTypes = {
    entityType: PropTypes.oneOf(['user', 'client', 'product', 'activity', 'task', 'fields']).isRequired,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool
};

CreateButton.defaultProps = {
    loading: false,
    disabled: false
};

export default CreateButton;